import Image from "next/image";
import Link from "next/link";

const SITEMAP = [
  {
    title: "Contact Us",
    menu: [
      "info@nubitsoft.com",
      "+92(21) 32428196-98",
      "Suite # 101-102, Roshan Trade Center (TAI), Near Naheed Super Market, Shaheed-e-Millat Road Karachi, Pakistan.",
    ],
  },
  {
    title: "Trending Tech",
    menu: ["Full Stack Development", "Machine Learning & AI", "NFT MarketPlace", "Cyber Security", "Augmented Reality"],
  },
  {
    title: "Industries",
    menu: [
      "Banking & Financial Services",
      "Education",
      "Healthcare",
      "Retail E-Commerce",
      "Stock Brokerage & Trading",
    ],
  },
  {
    title: "Quick Link",
    links: [
      { label: "About", href: "/about" },
      { label: "Privacy Policy", href: "/privacypolicy" },
      { label: "Contact", href: "/contact" },
      { label: "Facebook", href: "https://www.facebook.com/Nubitsoftware" },
      { label: "LinkedIn", href: "https://www.linkedin.com/company/nubit-software-pvt-ltd/" },
      { label: "YouTube", href: "https://www.youtube.com/@nubitsoft" },
    ],
  },
];

const CERTIFICATIONS = [
  { src: "/certificate3.jpeg", alt: "ISO 9001 Certification", width: 400, height: 504 },
  { src: "/certificate2.jpeg", alt: "ISO/IEC 27001 Certification", width: 400, height: 504 },
];

const ACCREDITORS = [
  { src: "/certificate1.jpeg", alt: "Intercert", label: "Certification body", name: "Intercert Inc." },
  { src: "/logo-en.svg", alt: "Standards Council of Canada", label: "Accreditation body", name: "Standards Council of Canada" },
  { src: "/certificate4.jpeg", alt: "International Accreditation Forum", label: "Assessment association", name: "Intl. Accreditation Forum" },
];

export function Footer() {
  return (
    <footer className="relative w-full bg-[#020617] text-white overflow-hidden">
      {/* top hairline accent */}
      <div className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-brand-500/60 to-transparent" />
      <div className="pointer-events-none absolute -top-24 left-1/2 -translate-x-1/2 h-64 w-[40rem] rounded-full bg-brand-600/10 blur-3xl" />

      <div className="relative mx-auto max-w-7xl px-6 sm:px-8">
        {/* Sitemap */}
        <div className="grid grid-cols-1 gap-10 py-16 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 justify-items-center md:justify-items-start">
          {SITEMAP.map(({ title, links, menu }) => (
            <div key={title} className="w-full max-w-[300px] md:max-w-none text-left">
              <h3 className="mb-6 font-semibold uppercase text-brand-300 text-xs tracking-[0.2em]">
                {title}
              </h3>

              <ul className="space-y-3 text-sm">
                {links?.map(({ label, href }) => {
                  const external = href.startsWith("http");
                  return (
                    <li key={label}>
                      <Link
                        href={href}
                        {...(external && { target: "_blank", rel: "noopener noreferrer" })}
                        className="inline-block text-slate-300 transition-all duration-200 hover:translate-x-1 hover:text-white"
                      >
                        {label}
                      </Link>
                    </li>
                  );
                })}

                {menu?.map((item) => (
                  <li key={item}>
                    <span className="inline-block text-slate-400">{item}</span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Certification card */}
        <div className="flex flex-col items-center gap-8 rounded-2xl border border-white/10 border-t-2 border-t-amber-400 bg-gradient-to-br from-[#0b1a3a] to-[#071022] px-6 py-6 lg:flex-row lg:justify-between lg:px-8">
          {/* Left: badges + heading */}
          <div className="flex flex-col items-center gap-6 text-center sm:flex-row sm:text-left">
            <div className="flex items-center gap-3">
              {CERTIFICATIONS.map(({ src, alt, width, height }) => (
                <Image
                  key={src}
                  src={src}
                  alt={alt}
                  width={width}
                  height={height}
                  className="h-[104px] w-auto rounded-lg bg-white object-contain"
                />
              ))}
            </div>

            <div>
              <h4 className="text-lg font-bold sm:text-xl">
                Certified for quality.{" "}
                <span className="text-amber-400">Certified For Security.</span>
              </h4>
              <p className="mt-2 text-sm text-slate-200 font-semibold">
                ISO 9001 and ISO/IEC 27001, certified by Intercert Inc.
              </p>
            </div>
          </div>

          {/* Right: accreditors */}
          {/* Right: accreditors */}
          <div className="flex flex-col items-center gap-4">
            <span className="relative self-start pb-2 text-sm font-bold uppercase tracking-wide text-amber-400 after:absolute after:bottom-0 after:left-0 after:h-[2px] after:w-2/3 after:bg-amber-400 after:content-['']">
              Conformity Assessment
            </span>

            <div className="flex flex-wrap items-stretch justify-center gap-y-6 lg:flex-nowrap lg:divide-x lg:divide-white/10">
              {ACCREDITORS.map(({ src, alt, label, name }) => (
                <div key={name} className="flex flex-col items-center px-6 text-center">
                  <div className="relative h-10 w-16 overflow-hidden rounded-md bg-white">
                    <Image
                      src={src}
                      alt={alt}
                      fill
                      sizes="64px"
                      className="object-contain p-1"
                    />
                  </div>
                  <span className="mt-3 text-xs text-slate-400">{label}</span>
                  <span className="text-xs font-semibold text-slate-200">{name}</span>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Copyright */}
        <div className="mt-10  py-6 text-sm text-slate-400">

        </div>
      </div>
    </footer>
  );
}